import Swiper from 'https://unpkg.com/swiper@7/swiper-bundle.esm.browser.min.js'

class collectionCarousel extends HTMLElement {
  constructor() {
    super()
    this.slides = this.dataset.slides || 1
    const swiper = new Swiper(this.querySelector('#featured_collection--carousel'), {
      // Optional parameters
      slidesPerView: this.slides,
      spaceBetween: 30,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      grabCursor: true,
      draggable: true,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        767: {
          slidesPerView: 5
        }
      }
    });
  }
}

customElements.define("collection-carousel", collectionCarousel);